export default (theme) => {
  return (value) => {
    value = theme.getLength(value);
    let matches = value.match(/^(\d+(?:\.\d+)?)(px|rem)$/);
    if (matches) {
      let [, number, unit] = matches;
      switch (unit) {
        case "px":
          return Number(number);
        case "rem":
          return Number(number) * 16;
      }
    }
  };
};
